import React, { useState } from "react";
import { useFormik } from "formik";
import isMobilePhone from "validator/lib/isMobilePhone";
import Reaptcha from "reaptcha";

import Container from "../../components/Container";
import Form from "../../components/Form";
import Button from "../../components/Button";

const AnthemEnroll = (props) => {
  const [sent, setSent] = useState(false);

  function handleSubmit(values) {
    let apiUrl = "https://app.joinpapa.com/rest-api/contact/eligible-life";

    window
      .post(apiUrl, {
        body: {
          client_name: "anthem",
          full_name: values.fullName,
          email: "",
          phone_number: values.phoneNumber,
          reason_for_contact: "",
          comment: "",
        },
      })
      .then(() => setSent(true));
  }

  const validate = (values) => {
    const errors = {};
    const { phoneNumber, ...otherValues } = values;
    const keys = Object.keys(otherValues);

    for (const key of keys) {
      if (!values[key]) {
        errors[key] = "Required";
      }
    }

    if (values.verified !== true) {
      errors.verified = "Captcha validation error.";
    }

    if (!phoneNumber) {
      errors.phoneNumber = "Required";
    } else if (!isMobilePhone(phoneNumber, "en-US")) {
      errors.phoneNumber = "Invalid phone number";
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: {
      verified: false,
      fullName: "",
      phoneNumber: "",
    },
    validate,
    onSubmit: (values, { setSubmitting }) => {
      handleSubmit({ ...values });
    },
  });

  return (
    <div className="form-page">
      <Container>
        {sent ? (
          <p>
            Thank you for reaching out to the Papa team! We'll reply back
            shortly.
          </p>
        ) : (
          <Form onSubmit={formik.handleSubmit} className="text-left">
            <Form.Group controlId="fullName">
              <Form.Label>Full Name:</Form.Label>
              <Form.Control
                name="fullName"
                placeholder="Full name"
                value={formik.values.fullName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.fullName && !!formik.errors.fullName}
              />
              {formik.touched.fullName && formik.errors.fullName ? (
                <Form.Feedback invalid>{formik.errors.fullName}</Form.Feedback>
              ) : null}
            </Form.Group>

            <Form.Group controlId="phoneNumber">
              <Form.Label>Phone number:</Form.Label>
              <Form.Control
                name="phoneNumber"
                placeholder="Phone number"
                value={formik.values.phoneNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={
                  formik.touched.phoneNumber && !!formik.errors.phoneNumber
                }
              />
              {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                <Form.Feedback invalid>
                  {formik.errors.phoneNumber}
                </Form.Feedback>
              ) : null}
            </Form.Group>

            <Form.Group>
              <Reaptcha
                sitekey={process.env.REACT_APP_CAPTCHA_SITEKEY}
                onVerify={() => {
                  formik.setFieldValue("verified", true);
                }}
              />
              {formik.touched.verified && formik.errors.verified && (
                <Form.Feedback invalid>{formik.errors.verified}</Form.Feedback>
              )}
            </Form.Group>

            <Form.Group className="text-center">
              <Button type="submit">Submit</Button>
              <a href="tel:+1-888-909-8177" className="phone-link">
                Call for more info <span>(1-888-909-8177)</span>
              </a>
            </Form.Group>
          </Form>
        )}
      </Container>
    </div>
  );
};

export default AnthemEnroll;
